import { useGrippContext, useStorageKeys } from '@gripp/shared-logic';
import { IconName, NavigationButton } from '@gripp/shared-ui';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { NavLinkProps } from '../../dashboard/components/menuLink';

export const AssetMenuItem = (props: NavLinkProps) => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const isActive = location.pathname.includes(props.route);
  const storageKeys = useStorageKeys();
  const { storageHandler } = useGrippContext();

  const onClick = async () => {
    await storageHandler.deleteItem(storageKeys.assetsScrollData);
    navigate(props.route);
  };

  return (
    <NavigationButton
      icon={props.icon as IconName}
      text={t(props.titleKey)}
      active={isActive}
      showIcon={true}
      showText={true}
      mode="light"
      collapsed={props.collapsed}
      onPress={onClick}
    />
  )
};
